var map = {
	"./yijia1.jpg": "8fc2",
	"./yijia2.jpg": "160a",
	"./yijia3.jpg": "dad3",
	"./yijia4.jpg": "a8b4",
	"./yijia5.jpg": "1502",
	"./yijia6.jpg": "27c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3fa9";